import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification, Radio, Row, Col } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import {  CONFIGURATION_METER } from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../Common/APIConstants";


const MeterPopupContent = ({
  onClose,
  isAdd, 
  form,
  selectedRow,
  isUpdate,
  refetch,
  setRefetch,
  width,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const location = useLocation();
  const [addFormdata, setAddFormData] = useState([])
  const modeselect = useSelector((state) => state.darkMode);
  const { isdarkMode } = modeselect;
  const [modules, setModules] = useState([])
  const [selectedSiteID, setSelectedSiteID] = useState(null);
  const [optionconverter, setOptionConverter] = useState([])
  const [selectedSiteName, setSelectedSiteName] = useState([])
  const [meterdetail, setMeterdetails] = useState([])
  const [meterlocation, setMeterLocation] = useState([])
  const [meterSuppliers, setMeterSupplier] = useState([])

  const handleClear = () => {
    form.resetFields(); 
  };

  const handleNotification = (msg,status) => {
    notification.open({
      message: msg,
      type: status,
      placement: 'topRight',
      duration: 3, 
    });
  };



  useEffect(() => {
    if (isAdd && selectedRow) {
      form.setFieldsValue(selectedRow);
    } else if (isUpdate && selectedRow) {
      form.setFieldsValue(selectedRow);
      setSelectedSiteName(selectedRow.sitename || ''); 
    } else {
      form.resetFields();
    }
  }, [isAdd, isUpdate, selectedRow, form]);
  console.log(selectedRow)

  useEffect(() => {
    if (isUpdate && selectedRow) {
      setSelectedSiteID(selectedRow.sitE_ID)
      
      form.setFieldsValue({
        meterid: selectedRow.meterid,
        metername: selectedRow.metername,
        metermodel: selectedRow.metermodel,
        portNo: selectedRow.portNo,
        sitename: selectedRow.sitename,
        active: selectedRow.active, 
        startingAddress: selectedRow.startingaddress,
        NoOfRegisters: selectedRow.numberOfRegisters,
        baudRate: selectedRow.baudRate,
        meterSupplier: selectedRow.meterSupplier,
        moduleID: selectedRow.moduleID,
        meterlocation: selectedRow.meterlocation,
        ipAddress: selectedRow.ipAddress,
        Description: selectedRow.description,
        Department: selectedRow.department,
      });
    }
  }, [isUpdate, selectedRow, form]);
  


  const handleAddFormChange = (changedValues, allValues) => {
    console.log(allValues)
    setAddFormData(allValues);
  };

  const fetchData = () => {
    if (selectedSiteID) {
      getModules();
      getConverter();
      meterdetails(selectedSiteID);
      meterLocation(selectedSiteID);
      // meterSupplier(selectedSiteID);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedSiteID]);

  const handleFormSubmit = async () => {
    try {
      const formData = form.getFieldsValue();
      console.log(formData.sitename);
      console.log(selectedSiteID);
      console.log(formData);
      
      // if (!formData.startingAddress) {
      //   formData.startingAddress = formData.ipAddress;
      // }

      const portNo = Number(formData.portNo) || 0; 
      const apiData = {
        departmentId: selectedSiteID || 0,
        siteId: selectedSiteID || 0,
        meterMeterId: String(formData.meteR_METERID	 || ""),
        meterName: formData.metername || "",
        meterModelName: formData.metermodel || "",
        department: formData.Department || "",
        siteName:  formData.sitename || "",
        description: formData.Description || "",
        meterLocation: formData.meterlocation || "",
        enabled: formData.active,
        startingAddress: formData.startingaddress || "",
        numberOfRegisters:String( formData.numberofregisters) || "",
        baudRate: formData.baudRate || "",
        meterSupplier: formData.meterSupplier || "",
        portNo: portNo||0,
        ipAddress: formData.ipAddress || "",
        module: formData.module||0,
        isReport: true,
      };
      

      const url = isUpdate ? APIConstants.UPDATE_CONFIG_METER : APIConstants.CONFIG_INSERT_METER;
      const method = isUpdate ? 'POST' : 'POST';

      const response = await makeRequest({
        type: method,
        url: url,
        body: apiData,
      });

      console.log(response.message)


      handleNotification(isUpdate ? 'Successfully Updated' :response.message|| 'Successfully Added','success');
      isUpdate? setRefetch(!refetch):''
      form.resetFields();
      onClose();

    } catch (err) {
      console.error("Failed to add or update meter:", err);
      handleNotification(`Failed to ${isUpdate ? 'update' : 'add'}. Error: ${err.message || 'Unknown error'}`);
    }
  };

  const handleLanConverterChange = (value, option) => {
    setSelectedSiteID(value);
    setSelectedSiteName(option.children); 
    form.setFieldsValue({ sitename: option.children }); 
    console.log(value);
    console.log(option.children);
  };  

  const getModules = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MODULES}`
    }).then((res) => {
      if(res&&res.length>0){
        setModules(res)
      }
      console.log("Get Modules :", res);
    })
  }

  useEffect(() => {
    getModules()
  }, [])

  const getConverter = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    }).then((res) => {
      console.log("Converter:", res);
      if(res&&res.length>0){
        setOptionConverter(res);
      }
    });
  };

  useEffect(() => {
    if (optionconverter.length === 0) {
      getConverter();
    }
  }, [optionconverter]);

    function filterByUniqueDescription(data) {
  const seenDescriptions = new Set();
  return data.filter(item => {
    if (seenDescriptions.has(item.description)) {
      return false;
    }
    seenDescriptions.add(item.description);
    return true;
  });
}
  const meterdetails = (siteID) => {
    if (!siteID) return;

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_METER_MODAL_DETAILS}?ConverterID=${siteID}`
    }).then((res) => {
      if(res&&res.length>0){
        console.log(res)
        setMeterdetails(res.map(item => ({
          modelId: item.modelid,
          modelName: item.modelname,
        })));
       console.log(filterByUniqueDescription(res))
        const data = filterByUniqueDescription(res)
        setMeterSupplier(data.map(item => ({
          modelid: item.modelid,
          meterSupplier: item.description,
        })));
      }
    });
  };


  useEffect(() => {
    meterdetails(selectedSiteID);
  }, [selectedSiteID]);

  const meterLocation = (siteID) => {
    if (!siteID) return;
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_METER_LOCATION}?ConverterID=${siteID}`
    }).then((res) => {
      setMeterLocation(res.map(item => ({
        locationId: item.meterlocationid,
        locationName: item.meterlocationname,
      })));
    })
  };



  useEffect(() => {
    meterLocation(selectedSiteID);
  }, [selectedSiteID])


  // const meterSupplier = (siteID) => {
  //   if (!siteID) return;
  //   makeRequest({
  //     type: APIConstants.GET,
  //     url: `${APIConstants.GET_DEVICES_DETAILS}?SiteID=${siteID}`
  //   }).then((res) => {
  //     console.log("Meter supplier :", res);
  //     setMeterSupplier(res)
  //   })
  // }

  // useEffect(() => {
  //   meterSupplier(selectedSiteID);
  // }, [selectedSiteID])

  return (

    <Form 
      form={form}
      onFinish={handleFormSubmit}
      name="add-group-form"
      className="font-bold w-[600px]"
      layout="vertical"
      onValuesChange={handleAddFormChange}
      initialValues={isAdd ? {} : selectedRow}
    >
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Device ID"
            name="meteR_METERID"
            rules={[{ required: true, message: "Please select device ID" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Device Name"
            name="metername"
            rules={[{ required: true, message: "Please select device name" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Port No"
            name="portNo"
            rules={[{ required: true, message: "Please select port number" }]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="LanConverter"
            name="sitename"
            rules={[{ required: true, message: "Please select LanConverter name" }]}
          >
            <Select
              className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
              dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
              onChange={handleLanConverterChange}
              value={selectedSiteID}
            >
              {optionconverter.map((item) => (
                <Option key={item.siteID} value={item.siteID}>
                  {item.siteName}
                </Option>
              ))}
            </Select>

          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Device Model"
            name="metermodel"
            rules={[{ required: true, message: "Please select device model" }]}>
            <Select
              className={`${isdarkMode ? 'custom-select-dark' : 'custom-select-light'}`}
              dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
              onChange={(value, option) => form.setFieldsValue({ metermodel: option.children })}>
              {meterdetail.map(item => (
                <Option key={item.modelId} value={item.modelId}>{item.modelName}</Option>
              ))}
            </Select>
          </Form.Item>

        </Col>
        <Col span={8}>
          <Form.Item
            label="Device Supplier"
            name="meterSupplier"
            rules={[{ required: true, message: "Please select device supplier" }]}
          >
            <Select
              className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
              dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
            >
              {meterSuppliers.map((item) => (
                <Option key={item.modelid} value={item.meterSupplier}>
                  {item.meterSupplier}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="IP Address"
            name="ipAddress"
            rules={[{ required: true, message: "Please select category name" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Starting Address"
            name="startingaddress"
            rules={[{ required: true, message: "Please select starting address" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="No Of Registers"
            name="numberofregisters"
            rules={[{ required: true, message: "Please select number of registers" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Baud rate"
            name="baudRate"
            rules={[{ required: true, message: "Please select baud rate" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Device Location"
            name="meterlocation"
            rules={[{ required: true, message: "Please select device location" }]}>
            <Select
              className={`${isdarkMode ? 'custom-select-dark' : 'custom-select-light'}`}
              dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
              onChange={(value, option) => form.setFieldsValue({ meterlocation: option.children })}>
              {meterlocation.map(item => (
                <Option key={item.locationId} value={item.locationId}>{item.locationName}</Option>
              ))}
            </Select>
          </Form.Item>

        </Col>
        <Col span={8}>
          <Form.Item
            label="Active"
            name={"active"}
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Modules"
            name="module"
            rules={[{ required: true, message: "Please select Module" }]}
          >
            <Select
              className={`${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
              dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
            >
              {modules.map((item) => (
                <Select.Option key={item.moduleId} value={item.moduleId}>
                  {item.moduleName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

        </Col>

      </Row>

      <Form.Item className="flex justify-end">
        <Button htmlType="submit" className=" mr-2">
          Save
        </Button>
        <Button className="" type="primary" onClick={handleClear}>
          Clear
        </Button>
      </Form.Item>
    </Form>


  )
};

const MeterPopup = ({ 
  isAdd,
  setIsAdd,  
  isUpdate, 
  selectedRow,
  setIsUpdate,
  title,
  refetch,
  setRefetch,
  width
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
 
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_METER}/meter-add-popup`) {
      setIsAdd(true);

      form.resetFields();
    } else {
      setIsAdd(false);

    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);   
    setIsUpdate(false); 
    navigate(`${CONFIGURATION_METER}`); 
    form.resetFields(); 
  };


  useEffect(() => {
    if (isAdd && !selectedRow) {
      form.resetFields(); 
    } else if (isUpdate && selectedRow) {
      form.setFieldsValue(selectedRow);
    }
  }, [isAdd, isUpdate, selectedRow, form]);
  console.log(selectedRow)




  return (
    <>

      <PopupUI
        popupContent={
          <MeterPopupContent
            onClose={handleClose}
            isAdd={isAdd}
            isUpdate={isUpdate}
            selectedRow={selectedRow}
            form={form}
            title={title}
            refetch={refetch}
            setRefetch={setRefetch}
          />
        }
        isAdd={isAdd}
        setIsUpdate={setIsUpdate}
        handleClose={handleClose}
        isOpen={isAdd || isUpdate}
        title={title}
        width={width}
      />

    </>
  );
};

export default MeterPopup;
